import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getHelpResponse = async ({ userQuery }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getHelp&companyid=${user.companyid}&userQuery=${encodeURIComponent(userQuery)}`
  );

  return response.data;
};

const useHelpQuery = (options = {}) => {
  return useMutation({
    mutationFn: getHelpResponse,
    ...options,
  });
}; 

export default useHelpQuery;

